import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    console.log("MilestoneListController connected", this.element)
    this.debouncedSearch = this.debounce(this.submitForm.bind(this), 150)
  }

  toggleFilter(event) {
    // Handle checkbox changes - submit form immediately
    console.log("Toggle filter clicked")
    this.submitForm()
  }

  handleKeydown(event) {
    // Prevent form submission on Enter key
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  filterMilestones(event) {
    // Trigger debounced search on input
    console.log("Filter milestones input:", event.target.value)
    this.debouncedSearch()
  }

  submitForm() {
    console.log("Submitting form", this.formTarget)
    if (this.hasFormTarget) {
      // Use requestSubmit to trigger Turbo's form handling
      this.formTarget.requestSubmit()
    }
  }

  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}

